export default "__VITE_ASSET__fe996697__"